// extracted by mini-css-extract-plugin
export default {"errorNotice":"ErrorNotice_errorNotice__UIc5z"};